export const defaultConfig = {
	showWMLConversion: '',
};
